module.exports = __webpack_public_path__ + "img/s.404e01e1.svg";